import { createFragment } from "./helpers"

// The one banner shared by every transient-failure retry path: frames
// (setup/turbo_frame_retry), and page visits and form submissions
// (setup/turbo_retry). One element, one id — two of these stacking up during a
// deploy would be worse than the outage they describe.
const BANNER_ID = "turbo-frame-retry-banner"

const CLOSE_BUTTON = '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'

// `warning` while we are still trying, `danger` once we have given up.
export function showRetryBanner(message, { final = false } = {}) {
  const alertType = final ? "danger" : "warning"
  let banner = document.getElementById(BANNER_ID)

  if (!banner) {
    const flash = document.getElementById("flash")
    if (!flash) return

    const html = `<div id="${BANNER_ID}" class="alert alert-dismissible alert-${alertType} fade show" role="alert" data-controller="alert" data-alert-auto-dismiss-value="false">${message}${CLOSE_BUTTON}</div>`
    flash.appendChild(createFragment(html))
  } else {
    banner.className = `alert alert-dismissible alert-${alertType} fade show`
    banner.innerHTML = message + CLOSE_BUTTON
  }
}

export function removeRetryBanner() {
  document.getElementById(BANNER_ID)?.remove()
}
